import * as React from 'react';

import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { CommandMenu } from '~/components/common/command-menu/command-menu';
import { QueryDevtools, RouterDevtools } from '~/router';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <CommandMenu />
      <RouterDevtools position="bottom-left" />
      <QueryDevtools position="bottom" />
    </>
  );
}
